import { createSlice } from '@reduxjs/toolkit'
import {
    defaultPage,
    defaultSize,
    defaultSortDir,
    defaultTotalElements,
    defaultSortBy,
    defaultTotalPages,
} from '../../../constants/index'

const initialState = {
    playgroundHistory: [],
    getSingleTTSOutput: null,
    getTtsConfig:[],
    getVcConfig: [],
    getLsConfig: [],
    historyPagination: [],
    pageable: {
        pageNo: defaultPage,
        pageSize: defaultSize,
        sortBy: defaultSortBy,
        sortDir: defaultSortDir,
        totalPages: defaultTotalPages,
        totalElements: defaultTotalElements,
    },
}

const playgroundSlice = createSlice({
    name: 'playgroundSlice',
    initialState: initialState,
    reducers: {
        historyFetched: (state, action) => {
            state.playgroundHistory = action.payload
        },

        historyPaginationFetched: (state, action) => {
            state.historyPagination = action.payload.content
            state.pageable = {
                ...state.pageable,
                pageNo: action.payload.pageNo,
                pageSize: action.payload.pageSize,
                totalElements: action.payload.totalElements,
                totalPages: action.payload.totalPages,
            }
        },

        ttsOutputFetchedById: (state, action) => {
            state.getSingleTTSOutput = action.payload
        },
        fetchTtsConfig: (state, action) => {
            state.getTtsConfig = action.payload
        },

         fetchVcConfig: (state, action) => {
            state.getVcConfig = action.payload
        },
         fetchLsConfig: (state, action) => {
            state.getLsConfig = action.payload
        },
        
        fetchVcConfig: (state, action) => {
            state.getVcConfig = action.payload
        },

        fetchLsConfig: (state, action) => {
            state.getLsConfig = action.payload
        },
    },
})

export default playgroundSlice